import { Caption } from '@sbab-ui/components'
import { useState } from 'react'
import { Transition } from '@headlessui/react'
import { track } from '../../../../../lib/tracking'
import { camelToKebab } from '../../../../../lib/utils'

interface Props {
  id: string
}
export default function FeedbackButtons({ id }: Readonly<Props>) {
  const [feedbackGiven, setFeedbackGiven] = useState(false)
  const [showFeedbackText, setShowFeedbackText] = useState(false)
  const [feedbackType, setFeedbackType] = useState('')

  const handleFeedback = (
    type: 'helpful' | 'not-helpful',
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.preventDefault()
    track(`customer-feedback-on-tooltip`, `${camelToKebab(id)}.${type}`)
    setFeedbackType(type)
    // Instant color change
    setFeedbackGiven(true)
    // Delay fade out of buttons and fade in of feedback text
    setTimeout(() => {
      setShowFeedbackText(true)
    }, 500)
  }

  return (
    <div className="flex">
      {!showFeedbackText ? (
        <>
          <Caption className="!mr-4 !mt-0">Var detta hjälpsamt?</Caption>
          <button
            className={`mr-2 border px-2 transition-colors ${
              feedbackGiven && feedbackType === 'helpful' ? 'bg-black text-surface-banana' : ''
            }`}
            aria-label="Det här var hjälpsamt"
            onClick={(event) => handleFeedback('helpful', event)}
          >
            <Caption className="!mt-0">Ja</Caption>
          </button>
          <button
            className={`mr-2 border px-2 transition-colors ${
              feedbackGiven && feedbackType === 'not-helpful' ? 'bg-black text-surface-banana' : ''
            }`}
            aria-label="Det här var inte hjälpsamt"
            onClick={(event) => handleFeedback('not-helpful', event)}
          >
            <Caption className="!mt-0">Nej</Caption>
          </button>
        </>
      ) : (
        <Transition
          show={showFeedbackText}
          appear={true}
          enter="transition-opacity duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Caption className="!mr-4 !mt-0 min-h-[23px]">Tack för din feedback!</Caption>
        </Transition>
      )}
    </div>
  )
}
